const pct = (v) => (v != null ? `${(Number(v) * 100).toFixed(1)}%` : "—");
const r1 = (v) => (v != null ? Number(v).toFixed(1) : "—");
const num = (v) => (v != null ? v : "—");

export const GROUPS = [
  {
    label: "Player",
    cols: [{ key: "player_name", label: "Player", align: "left", format: (v) => v ?? "—" }],
  },
  {
    label: "",
    cols: [{ key: "games", label: "G", format: num }],
  },
  {
    label: "Stolen Bases",
    cols: [
      { key: "sb", label: "SB", format: num },
      { key: "cs", label: "CS", format: num },
      { key: "sb_att", label: "Att", format: num },
      { key: "sb_pct", label: "SB%", colored: true, format: pct },
      { key: "sb_att_per_game", label: "Att/G", format: r1 },
    ],
  },
  {
    label: "2B Steals",
    cols: [
      { key: "sb_2b", label: "SB", format: num },
      { key: "cs_2b", label: "CS", format: num },
      { key: "att_2b", label: "Att", format: num },
      { key: "sb_2b_pct", label: "SB%", colored: true, format: pct },
      { key: "att_2b_per_game", label: "Att/G", format: r1 },
    ],
  },
  {
    label: "3B Steals",
    cols: [
      { key: "sb_3b", label: "SB", format: num },
      { key: "cs_3b", label: "CS", format: num },
      { key: "att_3b", label: "Att", format: num },
      { key: "sb_3b_pct", label: "SB%", colored: true, format: pct },
      { key: "att_3b_per_game", label: "Att/G", format: r1 },
    ],
  },
  {
    label: "Double Plays",
    cols: [
      { key: "gdp_opps", label: "Opp", format: num },
      { key: "gdp", label: "GDP", format: num },
      { key: "wgdp", label: "wGDP", colored: true, format: r1 },
    ],
  },
  {
    label: "Extra Bases",
    cols: [
      { key: "ebt_taken", label: "XBT", format: num },
      {
        key: "ebt_opps",
        label: "Opp",
        getValue: (r) => {
          const taken = r.ebt_taken ?? 0;
          const out = r.ebt_out ?? 0;
          return taken + out > 0 ? taken + out : null;
        },
        format: num,
      },
      {
        key: "xbt_pct",
        label: "XBT%",
        colored: true,
        getValue: (r) => {
          const opps = (r.ebt_taken ?? 0) + (r.ebt_out ?? 0);
          return opps ? r.ebt_taken / opps : null;
        },
        format: pct,
      },
      { key: "webt", label: "wXBT", colored: true, format: r1 },
    ],
  },
  {
    label: "Value",
    cols: [
      { key: "wsb", label: "wSB", colored: true, format: r1 },
      { key: "baserunning", label: "BsR", colored: true, format: r1, bold: true },
    ],
  },
];

export const ALL_COLS = GROUPS.flatMap((g) => g.cols);
